import {
  bannerImage1,
  bannerImage2,
  bannerImage3,
  featuredCategoryImage1,
  featuredCategoryImage2,
  featuredCategoryImage3,
  featuredCategoryImage4,
} from '../assets';

export const bannerSwiper = [
  {
    id: 'b1',
    title: 'Banner 1',
    image: bannerImage1,
    url: 'new-in',
  },
  {
    id: 'b2',
    title: 'Banner 2',
    image: bannerImage2,
    url: '',
  },
  {
    id: 'b3',
    title: 'Banner 3',
    image: bannerImage3,
    url: '',
  },
];

export const bannerCategories = [
  {
    id: 'b1',
    title: 'BACK IN STOCK',
    image: featuredCategoryImage1,
    url: 'product-cat/back-in-stock',
  },
  {
    id: 'b2',
    title: 'EVERYONE\'S FAVES',
    image: featuredCategoryImage2,
    url: 'product-cat/best-sellers',
  },
  {
    id: 'b3',
    title: 'BACK TO OFFICE',
    image: featuredCategoryImage3,
    url: 'product-cat/back-to-office',
  },
  {
    id: 'b4',
    title: 'SHOP UNDER 300K',
    image: featuredCategoryImage4,
    url: 'product-cat/under-300k',
  },
];

export const breadcrumbs = [
  {
    id: 'b1',
    url: '/',
    title: 'HOME',
  },
];
